import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UserCloseIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "15",
    cy: "7",
    r: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15,13a8.07,8.07,0,0,0-8,6.92,1,1,0,0,0,1,1.15H22a1,1,0,0,0,1-1.15A8.07,8.07,0,0,0,15,13Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "4",
    y: "7",
    width: "2",
    height: "8",
    rx: "1",
    transform: "translate(9.24 -0.31) rotate(45)"
  }), /*#__PURE__*/_jsx("rect", {
    x: "4",
    y: "7",
    width: "2",
    height: "8",
    rx: "1",
    transform: "translate(16.31 15.24) rotate(135)"
  })]
}), 'UserCloseIcon');